import React, { useEffect, useRef, useState } from "react";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { useForm, Controller } from "react-hook-form";
import { onAPIError } from "../../helper/functions";
import auth from "../../api/auth";
import { useAuth } from "../../helper/auth";

const RegisterMeterModal = ({ visible, onClose }) => {
  const { updateProfile } = useAuth();
  const meterNumberInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { meter_number: "" },
  });

  const onSubmit = async (data) => {
    const { meter_number } = data;
    setLoading(true);
    try {
      const { data } = await auth.registerMeter({ meter_number });
      setLoading(false);
      onClose();
      updateProfile(data.data);
    } catch (e) {
      console.log(e);
      onAPIError(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!visible) {
      reset();
    }
  }, [reset, visible]);

  return (
    <Modal
      dismissible={!loading}
      show={visible}
      size="md"
      popup
      onClose={onClose}
      initialFocus={meterNumberInputRef}
    >
      <Modal.Header />
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <h3 className="text-xl font-medium text-gray-900 dark:text-white">
            Register new meter
          </h3>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="meter_number" value="Meter number" />
            </div>
            <Controller
              control={control}
              name="meter_number"
              rules={{ validate: (v) => v?.trim()?.length > 7 }}
              render={({ field: { onChange, value } }) => (
                <TextInput
                  id="meter_number"
                  ref={meterNumberInputRef}
                  placeholder="20........"
                  required
                  onChange={onChange}
                  value={value}
                  color={errors.meter_number ? "failure" : ""}
                  helperText={
                    errors.meter_number && (
                      <>
                        <span className="font-medium">Oops!</span> Meter number
                        invalid!
                      </>
                    )
                  }
                />
              )}
            />
          </div>

          <div className="w-full">
            <Button type="submit" isProcessing={loading}>
              Submit
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RegisterMeterModal;
